export const HEATING_SYSTEMS_PATH = '/uslugi/gotovye-resheniya-pod-klyuch/sistemy-otopleniya-pod-klyuch/';

export const HEATING_PRELIMINARY_DESIGN_ID = '570';
export const HEATING_WORKING_DOCUMENTATION_ID = '573';

export const HEATING_SYSTEMS_CONSULTATION_TYPE = 'HEATING';

export const HEATING_SERVICE_TYPE_ID_LIST = [
  HEATING_PRELIMINARY_DESIGN_ID,
  HEATING_WORKING_DOCUMENTATION_ID,
];

export const HEATING_ELEMENT_BLOCK = 'landingSistemyOtopleniya';

export const SERVICE_ID_HEATING = '2107';
